module.exports = __webpack_public_path__ + "img/36378-064.1a17ddf2.jpg";